import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStudentMe } from '../../modules/roster/hooks/useStudentMe';
import { ROUTES } from '../../utils/constants';
import { isGrade2 } from '../../utils/studentGrade';
import { Spinner } from '../ui/Spinner';

interface StudentActivityGradeGateProps {
  children: React.ReactNode;
}

/**
 * Blocks `/student/activity` for roster-resolved Grade 2. Spinner while roster loads;
 * null/unknown grade after load allows access.
 */
export const StudentActivityGradeGate: React.FC<StudentActivityGradeGateProps> = ({ children }) => {
  const { grade, isRosterLoading } = useStudentMe();

  if (isRosterLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <Spinner size="lg" />
      </div>
    );
  }

  if (isGrade2(grade)) {
    return <Navigate to={ROUTES.STUDENT_DASHBOARD} replace />;
  }

  return <>{children}</>;
};
